import React, { useState } from 'react';
import { Zap, X } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import { useNavigate } from 'react-router-dom';

const UpgradeModal = ({ show, onClose, message }) => {
  const { darkMode } = useTheme();
  const navigate = useNavigate();
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
      <div className={`relative w-full max-w-sm rounded-2xl p-6 text-center ${darkMode ? 'bg-zinc-900' : 'bg-white'}`} onClick={e => e.stopPropagation()}>
        <button onClick={onClose} className={`absolute top-3 right-3 p-1 rounded-lg ${darkMode ? 'hover:bg-zinc-800 text-zinc-400' : 'hover:bg-gray-100 text-gray-400'}`}>
          <X className="h-4 w-4" />
        </button>
        <div className="w-14 h-14 rounded-full bg-orange-500/10 flex items-center justify-center mx-auto mb-4">
          <Zap className="h-7 w-7 text-orange-500" />
        </div>
        <h3 className={`text-lg font-bold mb-2 ${darkMode ? 'text-white' : 'text-gray-900'}`}>Limite atingido</h3>
        <p className={`text-sm mb-6 ${darkMode ? 'text-zinc-400' : 'text-gray-500'}`}>
          {message || 'Você atingiu o limite de uso no plano gratuito.'}
        </p>
        <div className="space-y-2">
          <button onClick={() => { onClose(); navigate('/planos'); }}
            className="w-full py-2.5 rounded-xl text-sm font-semibold text-white bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700">
            Ver planos
          </button>
          <button onClick={onClose}
            className={`w-full py-2.5 rounded-xl text-sm font-medium ${darkMode ? 'text-zinc-400 hover:bg-zinc-800' : 'text-gray-500 hover:bg-gray-100'}`}>
            Voltar amanhã
          </button>
        </div>
      </div>
    </div>
  );
};

// Hook pra usar em qualquer página
export const useUpgradeModal = () => {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState('');

  const checkAndShowUpgrade = (error) => {
    const data = error?.response?.data;
    if (data?.error === 'LIMITE_IA_DIARIO' || data?.message?.includes?.('Limite diário')) {
      setMessage(data.message);
      setShow(true);
      return true;
    }
    return false;
  };

  const modal = <UpgradeModal show={show} onClose={() => setShow(false)} message={message} />;

  return { checkAndShowUpgrade, modal };
};

export default UpgradeModal;
